"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _object = require("lodash/object");

var _state = _interopRequireDefault(require("./state"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var updateState = function updateState(state, call, patch) {
  return _objectSpread({}, state, {
    calls: _objectSpread({}, state.calls, _defineProperty({}, call, _objectSpread({}, (0, _object.get)(state, "calls.".concat(call)), patch)))
  });
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _state.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.CALL_API:
      {
        return !action.call ? state : updateState(state, action.call, {
          fetching: true
        });
      }

    case _actions.CALL_API_FAIL:
      {
        return !action.call ? state : updateState(state, action.call, {
          fetching: false,
          error: true,
          success: false
        });
      }

    case _actions.CALL_API_SUCCESS:
      {
        return !action.call ? state : updateState(state, action.call, {
          fetching: false,
          error: false,
          success: true
        });
      }

    default:
      return state;
  }
};

exports.default = _default;